export const PersonTypeEnum = Object.freeze({
    Board: 1,
    ScientificCommittee: 2,
    Researchers: 3
});

export default PersonTypeEnum;